import React        from 'react'
import { observer } from 'mobx-react'
import SSButton     from 'ui/shell/SSButton'
import SSAlert      from 'ui/shell/SSAlert'

const FailedRoute = () => (
  <div>
  <p
    style={{fontSize: '22px', fontWeight: '400', color: '#111827'}}
    className="mb-4"
  >
    Email verification error
  </p>
  <Message/>
  </div>

)

const Message = () => (
  <div>
    <p className="mb-4 text-body">
      In order to reset your password, we will need to verify your
      email first.
      <br />
      Would you like to verify your email?
    </p>
    <SSButton
      style={{backgroundColor: 'black', color: 'white', borderRadius: '8px'}}
      className="w-100"
      onClick={reset}
      size="lg"
      className="mb-5"
    >
      Verify Email
    </SSButton>
  </div>
)

function reset() {
  window.location.replace('/reset')
}

export default observer(FailedRoute)
